/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/eurovision-control/eurovision-control.d.ts" />

namespace Application.Directives {
    'use strict';
    /**
     * Factory callback type
     */
    declare type EurovisionDatetimePickerDirectiveCb = ($timeout: ng.ITimeoutService) => EurovisionDatetimePickerDirective;

    /**
     * Custom scope
     */
    export interface IEurovisionDatetimePickerDirectiveScopeDef {
        type: string;
        name: string;
        value: string;
        format: string;
        placeholder: string;
    }

    /**
     * Custom scope
     */
    export interface IEurovisionDatetimePickerDirectiveScope extends ng.IScope {
        type: 'date' | 'time';
        name: string;
        value: string;
        format: string;
        placeholder: string;

        elementId: string;
    }

    export class EurovisionDatetimePickerDirective implements ng.IDirective {
        public static $name: string = "eurovisionDatetimePicker";
        public static $inject: string[] = ['$timeout'];
        
        public restrict: string = 'E';
        public transclude: boolean = false;
        public templateUrl: string = 'decorators/eurovision-datetime-picker-directive.html';
        public link: (scope: IEurovisionDatetimePickerDirectiveScope, element: JQuery, attrs: ng.IAttributes) => void;
        public scope: IEurovisionDatetimePickerDirectiveScopeDef = {
            type: '@',
            name: '@',
            value: '=',
            format: '@',
            placeholder: '@',
        };

        public static Factory(): EurovisionDatetimePickerDirectiveCb {
            let directive: EurovisionDatetimePickerDirectiveCb = ($timeout: ng.ITimeoutService) => {
                return new EurovisionDatetimePickerDirective($timeout);
            };
            directive.$inject = ['$timeout'];
            return directive;
        }

        constructor($timeout: ng.ITimeoutService) {
            EurovisionDatetimePickerDirective.prototype.link = (scope: IEurovisionDatetimePickerDirectiveScope,
                                                          element: JQuery,
                                                          attrs: ng.IAttributes) => {
                scope.elementId = Common.Utils.guid();
                $timeout(() => {
                    $('#' + scope.elementId).on('change', () => {
                        $timeout(() => {
                            scope.value = $('#' + scope.elementId).val();
                        });
                    });
                }, 190);

                scope.$on('$destroy', () => {
                    $('#' + scope.elementId).off('change');
                });
            };
        }
    }
}